import { Button, Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import INotificationSettings from "../../models/INotificationSettings";
import Services from "../../services/Services";
import snackbarService from "../../services/ui-messaging/SnackbarService";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";

interface NotificationSettingsProps {
  token: string;
}

const NotificationSettings = (props: NotificationSettingsProps) => {
  const { token } = props;
  const [settings, setSettings] = React.useState<INotificationSettings | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    const getSettings = async () => {
      const notificationRepo = await new Services().NotificationRepository();
      try {
        setIsLoading(true);
        setSettings(await notificationRepo.get(token));
      } catch (err) {
        snackbarService.error(err);
      }

      setIsLoading(false);
    };

    getSettings();
  }, []);

  const handleSave = async () => {
    if (settings === null) {
      return;
    }

    const notificationRepo = await new Services().NotificationRepository();

    try {
      setIsLoading(true);
      setSettings(await notificationRepo.update(token, settings));
      snackbarService.success("Successfully updated Notification Settings");
    } catch (err) {
      snackbarService.error(err);
    }

    setIsLoading(false);
  };

  return (
    <WithLoadingSpinners message="Gathering data" isLoading={isLoading}>
      {settings && (
        <Grid container>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name="optOutPartnerPortal"
                  onChange={event => setSettings({ OptOutPartnerPortal: event.target.checked })}
                  checked={settings.OptOutPartnerPortal}
                />
              }
              label="Opt Out of Partner Portal emails"
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" color="primary" size="large" onClick={handleSave}>
              Save
            </Button>
          </Grid>
        </Grid>
      )}
    </WithLoadingSpinners>
  );
};

const ConnectedSettings = connect((state: IApplicationState) => {
  return selectAuth(state);
})(NotificationSettings);

export default ConnectedSettings;
